import { useTranslate } from "@/common/hooks/useTranslate";
import { FormChip } from "@/forms-design-system/FormChip";

export const PrimaryCampaignTypeChip = () => {
  const { t } = useTranslate();

  return <FormChip variant="outlined" label={t("donationForm", "peerToPeer.chip.generalCampaign")} />;
};
